import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import StepIndicator from "../layout/StepsIndicator";
import styles from '../../styles/addAnnoucement.module.scss'
import AddAnnoucementStep1 from "./steps/AddAnnoucementStep1";
import AddAnnoucementStep2 from "./steps/AddAnnoucementStep2";
import {Button} from "antd";
import {ANNOUCEMENT_FORM, validatedFirstStep, validatedSecondStep} from "../../utils/announcement.util";

export default function AddAnnoucement () {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState(ANNOUCEMENT_FORM);

    const updateFormData = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };
    
    const steps = [
        {
            component: <AddAnnoucementStep1 formData={formData} updateFormData={updateFormData} />,
        },
        {
            component: <AddAnnoucementStep2 formData={formData} updateFormData={updateFormData} />,
        },
    ];
    
    useEffect(() => {
        // If coming back from preview, restore form data
        if (location.state?.formData) {
            setFormData(location.state.formData);
            if (location.state.openFormTab) {
                // Optionally set the step if passed
                setCurrentStep(location.state.step || 0);
            }
        }
    }, [location.state]);
    
    const handlePreview = () => {
        // Navigate to preview page with form data
        if (!validatedSecondStep(formData)){
            return;
        }
        navigate('/objave/pregled', {
            state: {
                formData,
                mode: 'create'
            }
        });
    };
    
    const next = () => {
        if (!validatedFirstStep(formData)){
            return;
        }
        setCurrentStep(currentStep + 1);
    };

    const prev = () => {
        setCurrentStep(currentStep - 1);
    };
    
    useEffect(() => {
        if (location.state?.formData) {
            window.history.replaceState({}, document.title);
        }
    }, []);
    
    return (
        <div className={styles.addAnnouncementWrapper}>
            {/* Custom Step Indicator */}
            <StepIndicator currentStep={currentStep} totalSteps={steps.length} />

            {/* Step Content */}
            <div className={styles.stepsContent}>
                {steps[currentStep].component}
            </div>

            {/* Navigation Buttons */}
            <div className={styles.stepsAction}>
                {currentStep > 0 && (
                    <Button
                        className={`btn-tertiary`}
                        onClick={prev}
                    >
                        Nazad
                    </Button>
                )}
                {currentStep < steps.length - 1 && (
                    <Button
                        className={`btn-primary`}
                        onClick={next}
                    >
                        Nastavi
                    </Button>
                )}
                {currentStep === steps.length - 1 && (
                    <Button
                        className={`btn-primary`}
                        onClick={handlePreview}
                    >
                        Pregledaj objavu
                    </Button>
                )}
            </div>
        </div>
    );
}